export const ICON_PROJECT = 'project';

export const ICON_GROUP = 'group';

export const ICON_SUBGROUP = 'subgroup';

export const LARGE_AVATAR_PX = 32;

export const SMALL_AVATAR_PX = 16;

export const SEARCH_SHORTCUTS_MIN_CHARACTERS = 2;

export const SEARCH_INPUT_DESCRIPTION = 'search-input-description';

export const SEARCH_RESULTS_DESCRIPTION = 'search-results-description';

export const SCOPE_TOKEN_MAX_LENGTH = 36;

export const INPUT_FIELD_PADDING = 84;

export const FETCH_TYPES = ['generic', 'search'];
export const SEARCH_MODAL_ID = 'super-sidebar-search-modal';

export const SEARCH_INPUT_SELECTOR = 'input[role="searchbox"]';

export const SEARCH_RESULTS_ITEM_SELECTOR = '.gl-new-dropdown-item';

export const KEY_K = 'KeyK';

export const KEY_N = 'KeyN';

export const KEY_P = 'KeyP';

export const GLOBAL_SEARCH_MODAL_CLASS = 'global-search-modal';
